import { createContext, useContext, useState } from "react";

const PickerContext = createContext(null);

export function PickerProvider({ children }) {
  const [activePicker, setActivePicker] = useState(null);

  return (
    <PickerContext.Provider value={{ activePicker, setActivePicker }}>
      {children}
    </PickerContext.Provider>
  );
}

export function usePicker() {
  const ctx = useContext(PickerContext);
  if (!ctx) throw new Error("usePicker must be inside PickerProvider");
  return ctx;
}
